export const primevueIt = {
  accept: 'Sì',
  reject: 'No',
  choose: 'Scegli',
  upload: 'Carica',
  cancel: 'Annulla',
  clear: 'Pulisci',
  apply: 'Applica',
  close: 'Chiudi',
  dayNames: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
  dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
  dayNamesMin: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
  monthNames: [
    'Gennaio',
    'Febbraio',
    'Marzo',
    'Aprile',
    'Maggio',
    'Giugno',
    'Luglio',
    'Agosto',
    'Settembre',
    'Ottobre',
    'Novembre',
    'Dicembre',
  ],
  monthNamesShort: [
    'Gen',
    'Feb',
    'Mar',
    'Apr',
    'Mag',
    'Giu',
    'Lug',
    'Ago',
    'Set',
    'Ott',
    'Nov',
    'Dic',
  ],
  today: 'Oggi',
  weekHeader: 'Sett',
  firstDayOfWeek: 1,
  dateFormat: 'dd/mm/yy',
  weak: 'Debole',
  medium: 'Media',
  strong: 'Forte',
  passwordPrompt: 'Inserisci una password',
  emptyMessage: 'Nessun risultato',
  emptyFilterMessage: 'Nessun risultato per il filtro',
  emptySearchMessage: 'Nessun risultato di ricerca',
  emptySelectionMessage: 'Nessuna selezione',
}
